function createStylesheet(cssContent: string): HTMLStyleElement {
  const stylesheet = document.createElement("style");

  stylesheet.type = "text/css";
  stylesheet.textContent = cssContent;

  return stylesheet;
}

export { createStylesheet };
